var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26.48 24.789c-0.72656 0.078126-1.3398 0.57031-1.582 1.2578-0.23828 0.69141-0.058594 1.457 0.46094 1.9688l21.965 21.984-21.965 21.961c-0.39062 0.34766-0.62109 0.83984-0.63281 1.3633-0.015624 0.51953 0.18359 1.0273 0.55469 1.3945s0.87891 0.56641 1.3984 0.54688c0.52344-0.019531 1.0156-0.25391 1.3555-0.64453l21.965-21.965 21.961 21.965c0.34375 0.39062 0.83594 0.625 1.3594 0.64453 0.51953 0.019531 1.0273-0.17969 1.3984-0.54688 0.36719-0.36719 0.57031-0.875 0.55469-1.3945-0.011719-0.52344-0.24219-1.0156-0.63281-1.3633l-21.965-21.961 21.965-21.984c0.57812-0.56641 0.73438-1.4414 0.38281-2.1719-0.35156-0.73047-1.1328-1.1562-1.9375-1.0547-0.42969 0.058594-0.82422 0.25781-1.125 0.57031l-21.961 21.965-21.965-21.965c-0.40234-0.41797-0.97266-0.62891-1.5547-0.57031z",
    fill: "#c39a36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.8144e0df.svg";
export { ForwardRef as ReactComponent };